import React, { useState } from "react"
import css from "./OurJourneySection.scss"
import { sanitizer } from "@commonUtils"
import Overlay from "../Overlay"
import { useInView } from "react-intersection-observer"

const DwebTile = ({ data, openBottomSheet }) => {
    const [activeTile, setActiveTile] = useState(
        data.findIndex((tile) => tile.active) !== -1 ? data.findIndex((tile) => tile.active) : 0
    )

    return (
        <div className={`flex flexColumn ${css.journeyTiles}`}>
            {data.map((tile, index) => (
                <div
                    key={index}
                    className={`padding-0-24 padding-24-0 flex flexColumn ${css.tile}  ${
                        activeTile === index ? css.expanded : css.collapsed
                    }`}
                    style={{ backgroundColor: tile.backgroundColor }}
                    onMouseEnter={() => setActiveTile(index)}
                >
                    <img src={tile.logo.url} alt="Tile Logo" />
                    <div className={`flex flexColumn ${css.content}`}>
                        <div className={`headingExtraSmallRegular ${css.highlightText}`}>
                            {tile.highlightText}
                        </div>
                        <button
                            className={`pointer bodyLargeRegular flex ${css.readMoreBtn}`}
                            onClick={() => openBottomSheet()}
                        >
                            <img
                                src="https://onemg.gumlet.io/staging/6d0d9fab-7c27-49cd-98e1-249f8cdcf0d5.svg"
                                alt="Plus"
                            />
                            <div>{tile.cta.label}</div>
                        </button>
                        <img
                            src={tile.absImage.url}
                            alt="Component-11"
                            className={`${css.absimg} ${activeTile === index ? css.show : ""}`}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

const MwebTile = ({ data, openBottomSheet }) => {
    const [activeTile, setActiveTile] = useState(1)

    return (
        <div className={`flex flexColumn ${css.journeyTiles}`}>
            {data.map((tile, index) => {
                const isExpanded = activeTile === index + 1
                return (
                    <div
                        key={index}
                        className={`padding-0-24 padding-24-0 ${css.tileMweb} flex flexColumn ${
                            isExpanded ? css.expanded : css.collapsed
                        }`}
                        style={{ backgroundColor: tile.backgroundColor }}
                        onMouseEnter={() => setActiveTile(index + 1)}
                    >
                        <img src={tile.logo.url} alt="tile-logo" border="0" />
                        <div className={`flex flexColumn ${css.content}`}>
                            <div className={`headingExtraSmallRegular ${css.highlightText}`}>
                                {tile.highlightText}
                            </div>
                            <button
                                className={`pointer bodyLargeRegular  flex ${css.readMoreBtn}`}
                                onClick={() => openBottomSheet(data)}
                            >
                                <img src="https://i.ibb.co/jR3XWvk/Plus.png" alt="Plus" />
                                <div>{tile.cta.label}</div>
                            </button>
                            <img
                                src={tile.absImage.url}
                                alt="tile-abs"
                                className={`${css.absimg} ${isExpanded ? css.show : ""}`}
                            />
                        </div>
                        {!isExpanded && (
                            <div className={`${css.plusIcon}`}>
                                <img
                                    src="https://i.ibb.co/jR3XWvk/Plus.png"
                                    alt="Plus"
                                    style={{ width: 24, height: 24 }}
                                />
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

const OurJourneySection = ({ data }) => {
    const [showSheet, setShowSheet] = useState(false)
    const [sheetData, setSheetData] = useState(null)
    const openBottomSheet = (data) => {
        setSheetData(data)
        setShowSheet(true)
    }
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1,
    })
    const getSheetData = () => {
        if (!sheetData) return null

        const details = sheetData?.details
        const list = sheetData?.list

        return (
            <div style={{ width: "90vw", height: "90vh" }} className="padding-0-40 padding-40-0">
                <img
                    src={"https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg"}
                    alt="tile-logo"
                />
                <div className="l1SemiBold padding-24-0">
                    Increase employee participation in annual health <br /> checkup programs.
                </div>
                <div className="padding-16-0">
                    <div className="l3SemiBold">Challenges</div>
                    <div className="l4Regular">
                        Low awareness of checkup benefits.Inconvenient scheduling.Perceived lack of <br />
                        value.Confidentiality concerns.
                    </div>
                </div>
                <div>
                    <div className=" l3SemiBold">Solution</div>
                    <div className="l4Regular">
                        <ul>
                            {details.map((item, index) => (
                                <li key={index}>
                                    <strong>{item.type}:</strong>
                                    <div> {item.description}</div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="padding-24-0">
                    <div className=" l3SemiBold">Impact</div>
                    <div className="l4Regular">
                        {list.map((item, key) => (
                            <div
                                key={key}
                                className={`flex alignCenter padding-16-0 `}
                                style={{ position: "relative" }}
                            >
                                <img
                                    style={{ position: "absolute", left: 0 }}
                                    src="https://i.ibb.co/HHTYR6f/Union.png"
                                    className={`${css.solutionsListLogo}`}
                                />
                                <p className="l3SemiBold textPrimary padding-0-16">{item}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="padding-8-0">
                    <div className="l3SemiBold ">Conclusion</div>
                    <div className="l4Regular">
                        Successfully increased participation in annual health checkups by addressing key
                        barriers and implementing a comprehensive, employee-focused strategy.
                    </div>
                </div>
            </div>
        )
    }

    if (!data.showSection) {
        return <></>
    }

    return (
        <section ref={ref} id="ourCustomer" className="container-fluid flex page-container">
            <div className="col-24">
                <div className={`opacity-none ${css.ourCustomerHeader} ${inView ? "slideUpFast" : ""}  `}>
                    <h2
                        className="sectionHeader"
                        dangerouslySetInnerHTML={{
                            __html: sanitizer(data.header),
                        }}
                    />

                    <h3 className="sectionSubHeader">{data.subheader}</h3>
                </div>
                <div className={`opacity-none ${inView ? "slideUp" : ""} `}>
                    {data.showCaseStudies && (
                        <>
                            <div className={`hideMweb`}>
                                <div className={`flex ${css.jounerySection}`}>
                                    {data.partners.map((item, key) => {
                                        return (
                                            <DwebTile
                                                key={key}
                                                data={item}
                                                openBottomSheet={openBottomSheet}
                                            />
                                        )
                                    })}
                                </div>
                            </div>

                            <div className={`hideDweb ${css.journeySection}`}>
                                <MwebTile data={data.partnersMweb} openBottomSheet={openBottomSheet} />
                            </div>
                        </>
                    )}
                    {data.showCaseStudies && (
                        <div className={`headingExtraSmallRegular `}>{data.subText}</div>
                    )}
                    <div className={`flex  padding-8-0 justifyBetween ${css.overflowX} ${css.partnersList}`}>
                        {data.otherPartners.map((item, key) => {
                            return <img key={key} src={item.url} />
                        })}
                    </div>
                </div>
            </div>
            <Overlay
                show={showSheet}
                toggle={() => setShowSheet(false)}
                size={"full"}
                showCloseIcon={true}
                toggleOnEmptyScreenClick={true}
            >
                {getSheetData()}
            </Overlay>
        </section>
    )
}

export default OurJourneySection
